<template>
    <div class="box-card p-8 m-2">
        <div class="user-toolbar">
            <div>
                <h3 class="user-title">All Team</h3>
                <p class="user-subtitle">{{ teamData.length }} teams</p>
            </div>

            <el-button size="small" class="Combtn" plain @click="handleCreateTeamClick" type="primary"
                v-if="!isLogistics && !isLogisticsView">
                Create Team
            </el-button>
        </div>

        <el-row class="team-body" v-loading="teamLoading">
            <!-- LEFT: TEAM LIST -->
            <el-col :span="10" class="content">
                <div class="team-list-scroll">
                    <div class="Cstlist" v-for="(item, index) in teamData" :key="item.teamId || index"
                        :class="{ active: active == index }" @click="handleSelectTeam(index, item)">
                        <div>
                            <el-avatar :size="29" :src="circleUrl"></el-avatar>
                        </div>

                        <div class="text">
                            <p style="text-transform: uppercase;">{{ item.teamName }}</p>
                            <p>{{ item.userCount || 0 }} Members</p>
                        </div>

                        <div class="sds-actions">
                            <div class="Cstbtn" v-if="!isLogistics && !isLogisticsView">
                                <el-dropdown trigger="click">
                                    <span class="el-dropdown-link">
                                        <i class="el-icon-more"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native.stop="handleEditTeamClick(item)">
                                            Edit Team
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native.stop="handleDeleteTeamClick(item)">
                                            Delete Team
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>

            <!-- RIGHT: TEAM MEMBER LIST -->
            <el-col :span="14" class="Comtable px-2">
                <div class="memberHeader" v-if="selectedTeam">
                    <div class="memberTitle">
                        <h3>{{ selectedTeam.teamName }}</h3>
                    </div>

                    <el-button size="small" plain type="primary" @click="handleAddUserClick"
                        v-if="!isLogistics && !isLogisticsView">
                        Add User
                    </el-button>
                </div>
                <el-table height="100%" :data="tableData" :cell-style="getCellStyle" :header-cell-style="{
                    height: '55px',
                    background: '#fff',
                    'border-top': '2px solid #D6D9E1 ',
                    'border-bottom': '1px solid #D6D9E1',
                }">
                    <el-table-column align="left" type="index" label="No" />
                    <el-table-column align="left" prop="nickName" label="Name" />
                    <el-table-column align="left" prop="email" label="Email Address" />
                    <el-table-column align="left" prop="roleLabel" label="Role" />
                    <el-table-column align="left" prop="status" label="Status" min-width="180">
                        <template slot-scope="scope">
                            <el-tag class="Statustag"
                                :type="scope.row.status == '0' ? 'success' : scope.row.status == '1' ? 'danger' : 'pink'"
                                disable-transitions
                                :color="scope.row.status == '0' ? '#CEF9CD' : scope.row.status == '1' ? '#FFE6E1' : '#FFEFD9'">
                                {{
                                    scope.row.status == "0"
                                        ? $t("state.Active")
                                        : scope.row.status == "1"
                                            ? $t("state.Deactivated")
                                            : $t("state.PendingVerification")
                                }}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column align="right" fixed="right" v-if="!isLogistics && !isLogisticsView" max-width="50">
                        <template slot-scope="scope">
                            <el-dropdown v-if="scope.row.status == 0 || scope.row.status == 1 || scope.row.status == 3"
                                trigger="click">
                                <span class="el-dropdown-link">
                                    <i class="el-icon-more"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleRemoveMemberClick(scope.row)">
                                        Remove From Team
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <el-dropdown v-else trigger="click">
                                <span class="el-dropdown-link">
                                    <i class="el-icon-more"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleRemoveMemberClick(scope.row)">
                                        Remove From Team
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <!-- CREATE TEAM -->
        <el-dialog width="360px" title="Create Team" :visible.sync="createTeamDialogVisible">
            <el-form ref="teamForm" size="small" label-position="top" :model="teamForm" :rules="teamRules">
                <el-form-item label="Team Name" prop="teamName">
                    <el-input size="small" v-model="teamForm.teamName" clearable />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleSaveTeamClick">Save</el-button>
            </div>
        </el-dialog>

        <!-- EDIT TEAM -->
        <el-dialog width="360px" title="Edit Team" :visible.sync="editTeamDialogVisible">
            <el-form ref="editTeamFormRef" size="small" label-position="top" :model="editTeamForm" :rules="teamRules">
                <el-form-item label="Team Name" prop="teamName">
                    <el-input size="small" v-model="editTeamForm.teamName" clearable />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="mini" @click="handleUpdateTeamClick">Save</el-button>
            </div>
        </el-dialog>

        <!-- ADD USER TO TEAM -->
        <el-dialog width="420px" title="Add User" :visible.sync="addUserDialogVisible"
            @opened="handleAddUserDialogOpened">
            <el-form ref="memberFormRef" size="small" label-position="top" :model="memberForm" :rules="memberRules">
                <el-form-item label="User" prop="userId">
                    <v-select v-model="selectedUsers" :options="unassignUserOptions" :filterable="false"
                        :multiple="true" label="nickName" placeholder="Select unassigned users"
                        @search="handleSearchUser" @open="handleOpenUserDropdown" @close="handleCloseUserDropdown">
                        <template #option="{ nickName, email }">
                            <div class="user-option">
                                <div class="user-option-name">{{ nickName }}</div>
                                <div class="user-option-email">{{ email }}</div>
                            </div>
                        </template>

                        <template #selected-option="{ nickName }">
                            <span class="selected-user">{{ nickName }}</span>
                        </template>

                        <template #list-footer>
                            <div v-if="unassignUserLoading" class="user-dropdown-loading">
                                <i class="el-icon-loading"></i>
                            </div>
                        </template>

                        <template #no-options>
                            <div class="no-option">
                                {{ unassignUserLoading ? "Loading users..." : "No users found" }}
                            </div>
                        </template>
                    </v-select>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="secondary" plain @click="addUserDialogVisible = false">Cancel</el-button>
                <el-button type="primary" @click="handleSaveMemberClick">
                    Save
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getCellStyle } from "@/utils/getCellStyle";
import {
    getTeamList,
    getTeamMemberList,
    createTeam,
    deleteTeam,
    unFreezeUser,
    revalidateEmail,
    updateTeam,
    getUnassignedUsers,
    addTeamMember,
    removeTeamMember,
} from "@/services/user";
import { mapState } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const roleMap = {
    1: "Terminal Logistics",
    2: "Terminal Control Room",
    3: "Terminal Team Leader",
    10: "Terminal Pilot",
    11: "Terminal Loading Master",
    12: "Terminal Head Of Pilot",
    13: "Terminal Inspector",
    16: "Terminal Logistics View",
};

export default {
    name: "company-team",
    components: {
        vSelect,
    },

    data() {
        return {
            searchInput: "",
            teamData: [],
            tableData: [],
            selectedTeam: null,
            active: "",
            teamLoading: true,
            circleUrl:
                "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

            createTeamDialogVisible: false,
            editTeamDialogVisible: false,
            addUserDialogVisible: false,

            teamForm: {
                teamName: "",
            },
            editTeamForm: {
                teamId: "",
                teamName: "",
            },
            memberForm: {
                userId: "",
            },

            unassignUserOptions: [],
            unassignUserTotal: 0,
            unassignUserPageNum: 1,
            unassignUserPageSize: 10,
            unassignUserLoading: false,
            unassignUserLoadingMore: false,
            unassignUserHasMore: true,
            unassignUserScrollEl: null,
            selectedUsers: [],

            teamRules: {
                teamName: [{ required: true, message: "Please Input", trigger: "blur" }],
            },
            memberRules: {
                userId: [{ required: true, message: "Please Select", trigger: "change" }],
            },

            roleList: [
                { value: "1", label: "Terminal Logistics" },
                { value: "2", label: "Terminal Control Room" },
                { value: "3", label: "Terminal Team Leader" },
                { value: "10", label: "Terminal Pilot" },
                { value: "11", label: "Terminal Loading Master" },
                { value: "12", label: "Terminal Head Of Pilot" },
                { value: "13", label: "Terminal Inspector" },
                { value: "16", label: "Terminal Logistics View" },
            ],
        };
    },

    created() {
        this.getList();
    },

    beforeDestroy() {
        this.removeUnassignUserScrollListener();
    },

    computed: {
        ...mapState(["userInfo", "screenType"]),
        isLogistics() {
            return this.userInfo.userType == 1 && this.userInfo.role == 1;
        },
        isLogisticsView() {
            return this.userInfo.userType == 1 && this.userInfo.role == 16;
        },
        isMobileScreen() {
            return this.screenType?.isMobileScreen ?? false;
        },
    },

    methods: {
        getCellStyle,

        getList() {
            this.teamLoading = true;

            getTeamList(this.searchInput)
                .then((res) => {
                    if (res.code == 200) {
                        this.teamData = res.rows || [];

                        this.$emit("list");

                        if (this.teamData.length > 0) {
                            const firstIndex = this.active === "" ? 0 : this.active;
                            const firstItem = this.teamData[firstIndex] || this.teamData[0];

                            this.handleSelectTeam(firstIndex, firstItem);
                        } else {
                            this.tableData = [];
                            this.selectedTeam = null;
                            this.active = "";
                        }
                    }
                })
                .finally(() => {
                    this.teamLoading = false;
                });
        },

        handleSearch() {
            this.active = "";
            this.getList();
        },

        handleSelectTeam(index, item) {
            this.active = index;
            this.selectedTeam = item;

            getTeamMemberList(item.teamId).then((res) => {
                if (res.code == 200) {
                    this.tableData = (res.data || []).map((user) => ({
                        ...user,
                        roleLabel: roleMap[user.role] || user.role,
                    }));
                }
            });
        },

        handleCreateTeamClick() {
            this.teamForm = {
                teamName: "",
            };

            this.createTeamDialogVisible = true;
        },

        handleSaveTeamClick() {
            this.$refs.teamForm.validate((valid) => {
                if (!valid) return;
                const teamName = this.teamForm.teamName.trim();
                const normalized = teamName.trim().toLowerCase();
                const exists = this.teamData.some(
                    t => t.teamName.trim().toLowerCase() === normalized
                );

                if (exists) {
                    this.$message.error("Team name already exists");
                    return;
                }

                createTeam({
                    teamName,
                }).then((res) => {
                    if (res.code == 200) {
                        this.createTeamDialogVisible = false;
                        this.$message.success(this.$t("status.success"));
                        this.getList();
                    }
                });
            });
        },

        handleEditTeamClick(item) {
            this.editTeamForm = {
                teamId: item.teamId,
                teamName: item.teamName,
            };

            this.editTeamDialogVisible = true;
        },

        handleUpdateTeamClick() {
            this.$refs.editTeamFormRef.validate((valid) => {
                if (!valid) return;

                const teamName = this.editTeamForm.teamName.trim();
                const normalized = teamName.trim().toLowerCase();
                const exists = this.teamData.some(
                    t => t.teamName.trim().toLowerCase() === normalized
                );

                if (exists) {
                    this.$message.error("Team name already exists");
                    return;
                }

                updateTeam({
                    teamId: this.editTeamForm.teamId,
                    teamName: teamName,
                }).then((res) => {
                    if (res.code == 200) {
                        this.editTeamDialogVisible = false;
                        this.$message.success(this.$t("status.success"));
                        this.getList();
                    }
                });
            });
        },

        handleDeleteTeamClick(item) {
            this.$confirm(
                `This will permanently delete "${item.teamName}". Continue?`,
                "Warning",
                {
                    confirmButtonText: "Delete",
                    cancelButtonText: "Cancel",
                    type: "warning",
                }
            )
                .then(() => {
                    return deleteTeam(item.teamId);
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.$message.success(this.$t("status.success"));

                        if (this.selectedTeam?.teamId === item.teamId) {
                            this.selectedTeam = null;
                            this.tableData = [];
                            this.active = "";
                        }

                        this.getList();
                    }
                })
                .catch(() => {
                });
        },

        handleAddUserClick() {
            if (!this.selectedTeam) {
                this.$message.warning("Please select a team first");
                return;
            }

            this.selectedUsers = [];
            this.resetUserList();
            this.addUserDialogVisible = true;
        },

        handleOpenUserDropdown() {
            if (!this.unassignUserOptions.length) {
                this.resetUserList();
                this.loadUsers(true);
            }

            this.$nextTick(() => {
                const dropdown = document.querySelector(".vs__dropdown-menu");
                if (!dropdown) return;

                this.dropdownEl = dropdown;
                dropdown.removeEventListener("scroll", this.handleScroll);
                dropdown.addEventListener("scroll", this.handleScroll);
            });
        },

        handleCloseUserDropdown() {
            this.removeScrollListener();
        },

        handleSearchUser(search) {
            this.unassignUserKeyword = search;
            this.resetUserList();
            this.loadUsers(true);
        },

        resetUserList() {
            this.unassignUserOptions = [];
            this.unassignUserTotal = 0;
            this.unassignUserPageNum = 1;
            this.unassignUserHasMore = true;
        },

        loadUsers(reset = false) {
            if (this.unassignUserLoading) return;
            if (!reset && !this.unassignUserHasMore) return;

            const scrollTop = this.dropdownEl ? this.dropdownEl.scrollTop : 0;

            this.unassignUserLoading = true;

            getUnassignedUsers({
                pageNum: this.unassignUserPageNum,
                pageSize: this.unassignUserPageSize,
                keyword: this.unassignUserKeyword,
            })
                .then((res) => {
                    if (res.code == 200) {
                        const rows = res.rows || [];

                        this.unassignUserTotal = res.total || 0;

                        if (reset) {
                            this.unassignUserOptions = rows;
                        } else {
                            this.unassignUserOptions.push(...rows);
                        }

                        this.unassignUserHasMore =
                            this.unassignUserOptions.length < this.unassignUserTotal;

                        if (this.unassignUserHasMore) {
                            this.unassignUserPageNum += 1;
                        }

                        this.$nextTick(() => {
                            if (!reset && this.dropdownEl) {
                                this.dropdownEl.scrollTop = scrollTop;
                            }
                        });
                    }
                })
                .finally(() => {
                    this.unassignUserLoading = false;
                });
        },

        handleScroll(e) {
            const el = e.target;

            const reachBottom =
                el.scrollTop + el.clientHeight >= el.scrollHeight - 10;

            if (reachBottom) {
                this.loadUsers(false);
            }
        },

        removeScrollListener() {
            if (this.dropdownEl) {
                this.dropdownEl.removeEventListener("scroll", this.handleScroll);
                this.dropdownEl = null;
            }
        },

        handleSaveMemberClick() {
            if (!this.selectedUsers.length) {
                this.$message.warning("Please select user");
                return;
            }

            const userIds = this.selectedUsers.map((user) => user.userId);

            addTeamMember(
                this.selectedTeam.teamId,
                userIds,
            ).then((res) => {
                if (res.code == 200) {
                    this.addUserDialogVisible = false;
                    this.$message.success(this.$t("status.success"));
                    this.handleSelectTeam(this.active, this.selectedTeam);
                    this.getList();
                }
            });
        },

        handleEditMemberClick(row) {
            console.log("edit member", row);
        },

        handleFreezeMemberClick(row) {
            const req =
                row.status == 0 ? freezeUser(row.userId) : unFreezeUser(row.userId);

            req.then((res) => {
                if (res.code == 200) {
                    this.$message.success(this.$t("status.success"));
                    this.handleSelectTeam(this.active, this.selectedTeam);
                }
            });
        },

        handleRemoveMemberClick(row) {
            this.$confirm(
                `Confirm remove ${row.nickName || "this user"} from the team?`,
                "System Tips",
                {
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    type: "warning",
                }
            ).then(() => {
                removeTeamMember(
                    this.selectedTeam.teamId,
                    row.userId,
                ).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(this.$t("status.success"));
                        this.handleSelectTeam(this.active, this.selectedTeam);
                        this.getList();
                    }
                });
            });
        },

        handleResendRequestClick(row) {
            revalidateEmail(row.userId).then(() => {
                this.$message.success(this.$t("status.success"));
            });
        },
    },
};
</script>

<style scoped lang="scss">
.box-card {
    min-height: calc(100vh - 180px);
    padding: 16px;
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
}

/* Layout */
.team-body {
    display: flex;
    height: calc(100vh - 220px);
    min-height: 0;
    overflow: hidden; // prevent shared scroll
}

/* LEFT PANEL */
.content {
    height: 61vh;
    display: flex;
    flex-direction: column;
    padding: 8px;
    background: #f8fafc;
    border: 1px solid #edf0f5;
    border-right: none;
    border-radius: 10px 0 0 10px;
    overflow: hidden; // important
}

.team-list-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-right: 4px;
}

/* TEAM LIST ITEM */
.Cstlist {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 72px;
    padding: 12px;
    margin-bottom: 8px;
    box-sizing: border-box;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid transparent;
    border-radius: 10px;
    transition: all 0.2s ease;

    &:hover {
        border-color: #b9dff5;
        box-shadow: 0 4px 12px rgba(0, 140, 219, 0.08);
    }

    .el-avatar {
        flex: 0 0 auto;
    }

    .text {
        flex: 1;
        min-width: 0;
        word-break: break-word;

        p {
            margin: 0;
        }

        p:first-child {
            font-size: 13px;
            font-weight: 700;
            color: #1d1b20;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        p:last-child {
            margin-top: 4px;
            font-size: 11px;
            color: #82889c;
        }
    }
}

.active {
    background: #eef8ff;
    border-color: #008cdb;
    box-shadow: 0 4px 12px rgba(0, 140, 219, 0.12);
}

/* RIGHT PANEL */
.Comtable {
    height: 60vh;
    display: flex;
    flex-direction: column;
    padding: 12px;
    background: #ffffff;
    border: 1px solid #edf0f5;
    border-radius: 0 10px 10px 0;
    overflow: hidden; // important
}

.memberHeader {
    flex: 0 0 auto;
    min-height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4px 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #edf0f5;

    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: #1d1b20;
        text-transform: uppercase;
    }
}

/* Make table fill remaining height and scroll independently */
.member-table {
    flex: 1;
    min-height: 0;
}

/* Table styling */
::v-deep .el-table {
    border-radius: 8px;
}

::v-deep .el-table th.el-table__cell {
    padding: 0;
    background: #ffffff !important;
}

::v-deep .el-table th.el-table__cell>.cell {
    font-size: 11px;
    font-weight: 700;
    color: #1d1b20;
}

::v-deep .el-table__row>.el-table__cell {
    padding: 9px 0;
    border-bottom: 1px solid #edf0f5;
}

::v-deep .el-table__row>.el-table__cell>.cell {
    font-size: 11px;
    color: #1d1b20 !important;
}

::v-deep .el-table__row:hover>td {
    background-color: #f8fafc !important;
}

::v-deep .el-table::before {
    display: none;
}

/* Vue select */
::v-deep .vs__dropdown-toggle {
    min-height: 38px;
    border: 1px solid #82889c;
    border-radius: 8px;
    padding: 2px 6px;
}

::v-deep .vs__dropdown-menu {
    max-height: 260px;
    padding: 6px;
    border: 1px solid #d6d9e1;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(29, 27, 32, 0.12);
}

::v-deep .vs__dropdown-option {
    min-height: 54px;
    padding: 8px 10px;
    border-radius: 6px;
    color: #1d1b20;
}

::v-deep .vs__dropdown-option--highlight {
    background: #f3f8fc;
    color: #1d1b20;
}

::v-deep .vs__dropdown-option--selected {
    background: #eef8ff;
    color: #1d1b20;
}

::v-deep .vs__selected {
    background: #ffffff;
    border: 1px solid #42a5f5;
    color: #008cdb;
    border-radius: 14px;
    padding: 2px 8px;
    margin: 3px 4px 3px 0;
    font-size: 12px;
}

::v-deep .vs__search {
    font-size: 12px;
}

.user-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 42px;
}

.user-option-name {
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    color: #1d1b20;
}

.user-option-email {
    margin-top: 3px;
    font-size: 11px;
    line-height: 14px;
    color: #82889c;
}

.selected-user {
    font-size: 12px;
    font-weight: 500;
}

.no-option {
    padding: 12px;
    text-align: center;
    color: #82889c;
}

.user-dropdown-loading {
    display: flex;
    justify-content: center;
    padding: 10px 0;
    color: #008cdb;
}

.user-toolbar {
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4px 12px;
    border-bottom: 1px solid #edf0f5;
    margin-bottom: 12px;
}

.user-title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #1d1b20;
}

.user-subtitle {
    margin: 4px 0 0;
    font-size: 12px;
    color: #82889c;
}

/* Misc */
.sds-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 0 0 auto;
    margin-left: 4px;

    .Cstbtn {
        display: flex;
        align-items: center;
    }

    .el-dropdown-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        font-size: 18px;

        &:hover {
            background: #f1f5f9;
        }
    }
}

.el-icon-more {
    transform: rotate(90deg);
    color: #82889c;
}
</style>